import React, { useEffect, useRef } from 'react';
import styles from './BetaMessageBanner.module.css';

const BetaMessageBanner: React.FC = () => {
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const setVar = () => {
      const h = el.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--beta-banner-height', h + 'px');
    };
    setVar();
    window.addEventListener('resize', setVar);
    const ro = new ResizeObserver(setVar);
    ro.observe(el);
    return () => {
      window.removeEventListener('resize', setVar);
      ro.disconnect();
      document.documentElement.style.removeProperty('--beta-banner-height');
    };
  }, []);

  return (
    <div ref={ref} className={styles.betaBanner} role="status" aria-live="polite">
      Bu uygulama geliştirilme aşamasındadır. Bazı özellikler beklendiği gibi çalışmayabilir.
    </div>
  );
};

export default BetaMessageBanner;
